import { Link } from "react-router-dom";

function AdminDashboard() {
    return (
        <div className="container mt-5">
            <h2>Admin Dashboard</h2>
            <div className="mt-4">
                <Link to="/admin/add-product" className="btn btn-primary m-2">
                    Add Product
                </Link>

                <Link to="/admin/products" className="btn btn-success m-2">
                    Manage Products
                </Link>

                <Link to="/admin/orders" className="btn btn-success m-2">
                    Orders
                </Link>

                <Link to="/admin/users" className="btn btn-success m-2">
                    Users
                </Link>
                <Link to="/admin/feature-management">
                    Feature Management
                </Link>
            </div>
        </div>
    );
}

export default AdminDashboard;